import { type HiringIssue, hiringIssueMap } from './hiringIssueTypes'

// This is a direct mapping now but could be extended and want to keep FlagKey as its own thing
export type FlagKey = HiringIssue

export interface FlagAdvice {
  title: string
  impact: string
  recommendations: string[]
}

export const flagColorMap = {
  red: 'red',
  yellow: 'yellow',
  green: 'green',
} as const

export type FlagColor = keyof typeof flagColorMap

export const flagKeyMap = {
  ...hiringIssueMap,
}

export interface FlagTracking {
  advice: FlagAdvice | null
  // I think this is the list of questions which trigger this flag
  // Assumption is that more than one question can trigger the same flag
  // We want to know which question triggered the flag
  questions: string[]
}

export type AuditFlag = Record<FlagKey, FlagTracking>
